import loading from './Atom.gif'

const Loading = () => {
  return (
    <img style={{ display: 'block', width: '150px', height: '150px', margin: 'auto' }} src={loading} alt='loading gif' />
  )
}

export default Loading;
